/*
*  同意隐私协议
*/
import React, { useState, useEffect } from 'react';
import { observer } from "mobx-react-lite";
import { Checkbox, Button } from "antd";
import Loader from '@/common/helper/loader';
import Conf from '@/common/conf';

const Agree = observer((props) => {
  const { onClose, onSucc} = props;
 
  const [checkedAgree, setCheckedAgree] = useState(false);

  const handleAgree = (e) => {
    setCheckedAgree(e.target.checked);
  }
  
  const doAgreeSubmit = () => {
    if (checkedAgree) {
      Loader.setPrivacyRole('login');
      onClose();
    }
  };
  
  return (
    <div
      id="agree"
      className="flex flex-col items-center w-full max-w-425px pt-10px pb-5px"
    >
      <h2 className="text-20px font-bold">用户协议和隐私政策提示</h2>   
      <div className="mt-6px text-16px leading-22px">
        感谢您使用{Conf.appName}，为保障您的权利，您需要知晓并同意平台隐私政策及用户协议。我们将严格按照协议中的内容为您提供服务，并且为您的信息安全保驾护航。
      </div>
      <div className="flex items-center mt-16px self-start">
        <Checkbox onChange={handleAgree}>
          <div className="text-14px">
            我已阅读并接受
            <a target="_blank" className="text-[#173BA1]" href="/agreements/privacy">
              《隐私政策》
            </a>
            和
            <a target="_blank" className="text-[#173BA1]" href="/agreements/protocol">
              《用户协议》
            </a>
          </div>
        </Checkbox>
      </div>
      <div className="w-full">
        <Button 
          type='primary'
          disabled={!checkedAgree}
          className='!w-full !h-48px !text-16px !font-medium !mt-16px'
          style={{
            background: '#000'
          }}
          onClick={() => doAgreeSubmit()}
        >
          同意并使用
        </Button>

      </div>
    </div>
  )
});

export default Agree;